import React, { useEffect } from "react";
import ReactFacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import moment from "moment";

function FacebookLogin({ scope, socialresponse, onCancel }) {
    useEffect(() => {
        if (window.FB) {
            window.FB.init({
                version: "v12.0",
                appId: process.env.REACT_APP_FB_APP_ID,
                xfbml: "false",
                cookie: "false",
            });
        }
    }, []);

    return (
        <ReactFacebookLogin
            appId={process.env.REACT_APP_FB_APP_ID}
            fields="name,email,picture"
            version="12.0"
            authType="reauthenticate"
            authNonce={moment.now()}
            scope={scope}
            callback={(response) => socialresponse(response, "Facebook")}
            isMobile={false}
            disableMobileRedirect={true}
            render={({ onClick }) => (
                <div
                    onClick={() => {
                        onClick();
                        setTimeout(() => onCancel(), 2000);
                    }}>
                    Authenticate
                </div>
            )}
        />
    );
}

export default FacebookLogin;
